// @flow

class SMCardHelper {
  constructor(config: { STRIPE_PUBLISHABLE_KEY: string }) {
    this.stripeKey = config.STRIPE_PUBLISHABLE_KEY
  }

  stripeKey: string

  generateToken(
    cardInfo: {
      number: string,
      name: string,
      cvc: string,
      exp_month: number,
      exp_year: number,
    },
    callback: Function,
  ) {
    Stripe.setPublishableKey(this.stripeKey)
    Stripe.setLanguage('ja')
    Stripe.card.createToken(cardInfo, (status, response) => {
      if (response.error) {
        if (callback && callback.error) callback.error(response)
      } else {
        if (callback && callback.success) callback.success(response)
      }
    })
  }
}

export default SMCardHelper



// WEBPACK FOOTER //
// ./src/helpers/CardHelper.js